import patternize from '@sdk/helpers/formatters/patternize';
import { CODE_FORMAT } from './phone';

export const CELLPHONE_NUMBER_FORMAT = '#####-####';
export const CELLPHONE_NUMBER_REGEX = /^\9[0-9]{4}-[0-9]{4}$/;

export const CELLPHONE_FORMAT = `(${CODE_FORMAT}) ${CELLPHONE_NUMBER_FORMAT}`;
export const CELLPHONE_REGEX = /^\([1-9][0-9]\) \9[0-9]{4}-[0-9]{4}$/;

export default function cellphone(value = '') {
  if (['', undefined, null].includes(value)) {
    return false;
  }

  if (CELLPHONE_REGEX.test(patternize(value, { format: CELLPHONE_FORMAT }))) {
    return false;
  }

  return true;
}

cellphone.message = function message(value, options = {}) {
  return options.message || 'não é um número de celular válido';
};
